import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "report-migrate-modal",
  "data-keyboard": "true",
  tabindex: "-1",
  role: "dialog",
  "aria-labelledby": "report-migrate-modal-title",
  "aria-hidden": "true"
}
const _hoisted_2 = {
  class: "modal-dialog modal-dialog-centered",
  role: "document"
}
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h5", {
  class: "modal-title",
  id: "report-migrate-modal-title"
}, " Migrate Report ", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = { class: "modal-body" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "alert alert-danger" }, [
  /*#__PURE__*/_createElementVNode("h4", null, "Warning"),
  /*#__PURE__*/_createElementVNode("p", { class: "mb-2" }, [
    /*#__PURE__*/_createTextVNode(" If you provide a Report ID "),
    /*#__PURE__*/_createElementVNode("strong", null, "which has already been migrated"),
    /*#__PURE__*/_createTextVNode(", then the Report will be overwritten. ")
  ]),
  /*#__PURE__*/_createElementVNode("p", { class: "mb-0" }, " Any existing migrated images will be overwritten too. ")
], -1)
const _hoisted_9 = { class: "form-group row" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", { class: "col-sm-3 col-form-label" }, "Report ID", -1)
const _hoisted_11 = { class: "col-sm-9" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn btn-outline-secondary mr-auto",
  "data-dismiss": "modal"
}, "Cancel", -1)

import { ref, onMounted, computed, inject, getCurrentInstance } from 'vue';
import { useStore } from 'vuex';
import { useToast } from "vue-toastification";
import { useRouter } from 'vue-router';


export default /*#__PURE__*/_defineComponent({
  __name: 'ReportMigrateModal',
  setup(__props) {

const instance = getCurrentInstance();
const store = useStore();
const router = useRouter();
const toasted = useToast();
const actProperty: any = inject('actProperty');

// Reactive State
const reportRef = ref('');

// Vuex Getters and Actions
const report = computed(() => store.getters['reports/current']);

const migrateReport = async (ref: string): Promise<string> => {
  return store.dispatch('reports/migrateReport', ref);
};

// Methods
const reset = () => {
  reportRef.value = '';
  instance?.proxy?.$forceUpdate();
};

const migrate = async () => {
  migrateReport(reportRef.value)
    .then((ref: string) => {
      toasted.success('Report migrated OK');
      router.push(`/reports/${ref}`);
    })
    .catch((err: any) => {
      actProperty.displayError(err)
    });
};

// Lifecycle Hooks
onMounted(() => {
  reset();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", { class: "modal-header" }, [
          _hoisted_4,
          _createElementVNode("button", {
            type: "button",
            class: "close",
            "data-dismiss": "modal",
            "aria-label": "Close",
            onClick: reset
          }, _hoisted_6)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          _createElementVNode("div", _hoisted_9, [
            _hoisted_10,
            _createElementVNode("div", _hoisted_11, [
              _withDirectives(_createElementVNode("input", {
                class: "form-control",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((reportRef).value = $event))
              }, null, 512), [
                [_vModelText, reportRef.value]
              ])
            ])
          ])
        ]),
        _createElementVNode("div", { class: "modal-footer" }, [
          _hoisted_12,
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-primary",
            "data-dismiss": "modal",
            onClick: migrate
          }, "Migrate")
        ])
      ])
    ])
  ]))
}
}

})